module.exports = "/img/_/_/_/assets/images/creeper/battle/common//17.jpg?de2ba8a993d95232d4598cd28489e7ce";